import React from 'react'
import { Accordion, AccordionItem, AccordionButton, AccordionIcon, Box, useTheme, Heading } from '@chakra-ui/react'

export const AccordianComp = ( props ) => {
  // eslint-disable-next-line
  const theme = useTheme()
  return (
    <Accordion allowToggle
      onChange={props.onToggle}
      bg="brand.svtPlayBlack"
      color="white"
      {...props}>
      <AccordionItem
        isopen={props.toggle}>
        <AccordionButton
          py={1}
          px={2}
          outline="none">
          <Box flex={1} textAlign="left">
            <Heading fontWeight="medium" fontSize="lg" fontFamily="regular">
              {props.header}
            </Heading>
          </Box>
          <AccordionIcon color="white" />
        </AccordionButton>
      </AccordionItem>
    </Accordion>
  )
}